export type ProductKeyTypes =
    | undefined
    | "confluence"
    | "confluence-PaidLpConflDocumentation"
    | "confluence-PaidLpConflEngineering"
    | "confluence-PaidLpConflFeatures"
    | "confluence-PaidLpConflFeaturesCerebro"
    | "confluence-PaidLpConflTemplate"
    | "confluence-AnchorLpConfTeamwork"
    | "confluence-AnchorLpConfMarketing"
    | "confluence-AnchorLpConfLegal"
    | "confluence-AnchorLpConfHr"
    | "confluence-AnchorLpConfOperations"
    | "confluence-AnchorLpConfDesign"
    | "confluence-AnchorLpConfProgramMgmt"
    | "confluence-AnchorLpConfCustomerService"
    | "confluence-AnchorLpConfCollaboration"
    | "confluence-PaidLpConflCompetitors"
    | "confluence-PaidLpConfAnchorAutomation"
    | "confluence-PaidLpConfWorkManagementAutomation"
    | "confluence-PaidLpXflowRedesignExperiment"
    | "confluence-PaidLpConflProjectMgmt"
    | "confluence-PaidLpConflKeywords"
    | "confluence-PaidLpConflSubAnchor"
    | "customers"
    | "home"
    | "jira"
    | "jiraServiceDesk"
    | "jiraServiceManagement"
    | "jiraProductDiscovery"
    | "jiraServiceManagement-PaidLpJsmFeatures"
    | "jiraServiceManagement-PaidLpJsmFeaturesCerebro"
    | "jiraServiceManagement-PaidLpJsmIncidentChangeMgmt"
    | "jiraServiceManagement-PaidLpJsmItsm"
    | "jiraServiceManagement-PaidLpJsmServiceDesk"
    | "jiraServiceManagement-PaidLpJsmTicketing"
    | "jiraServiceManagement-AnchorLpJsmAsset"
    | "jiraServiceManagement-AnchorLpJsmDevops"
    | "jiraServiceManagement-AnchorLpJsmTeamCustomerservice"
    | "jiraServiceManagement-AnchorLpJsmTeamDesign"
    | "jiraServiceManagementAssets"
    | "jiraServiceManagementVirtualServiceAgent"
    | "jiraSoftware"
    | "jiraSoftware-PaidLpJiraFeatures"
    | "jiraSoftware-PaidLpJiraPm"
    | "jiraSoftware-PaidLpJiraRoadmaps"
    | "jiraSoftware-PaidLpJiraTemplate"
    | "jiraSoftware-PaidLpJiraTracker"
    | "jiraSoftwareFeature"
    | "enterprise"
    | "enterpriseContactSales"
    | "enterpriseContactThanks"
    | "try"
    | "404"
    | "bitbucket"
    | "trello"
    | "opsgenie"
    | "jiraWorkManagement"
    | "jiraAlign"
    | "atlassianAccess"
    | "atlassianGuard"
    | "support"
    | "bamboo"
    | "crowd"
    | "compass"
    | "atlas"
    | "softwareDevelopment"
    | "storybook"
    | "agile"
    | "search"
    | "rovo"
    | "loom"
    | "focus"
    | "nonProfitCalculator"
    | "uniform"
    | "strategyCollection"
    | "teamworkCollection"
    | "fastshift"
    | "sourcetreeapp";

type CommonComponentsTypes =
    | "linkButton"
    | "tab"
    | "card"
    | "carouselItem"
    | "link"
    | "button";

type CommonContainersTypes =
    | "navbarDropdown"
    | "navbar"
    | "globalNavWacDropdownContainer"
    | "globalNavSubnav"
    | "globalFooterV2"
    | "globalNavSearchResult"
    | "heroSection"
    | "cardSection"
    | "ctaSection"
    | "announcementBanner"
    | "priceBlock"
    | "priceFeaturesTable"
    | "priceBlockDropdownLocalized"
    | "infographicsSection"
    | "integrationsSection"
    | "freeBundles"
    | "customersSection"
    | "getTheMostSection"
    | "productSelector"
    | "resourcesSection"
    | "scrollPinnedSection"
    | "searchAiSummary"
    | "supportSection"
    | "platformSection"
    | "toast"
    | "dataCenterSection"
    | "siteSelectorModal"
    | "testimonialsSection"
    | "tabsMenu"
    | "tabsSection"
    | "productDiscussed"
    | "badgesSection"
    | "searchResult"
    | "searchBar"
    | "signup"
    | "siteName"
    | "priceBlockBuyNow"
    | "homepageTailoredOnboarding"
    | "confluenceCrossFlowHeroSection"
    | "heroJSMJPDTemplates"
    | "jsmCrossFlowHeroSection"
    | "videoEmbedInline"
    | "bodyContentInline"
    | "bannerAlert"
    | "button"
    | "card"
    | "contentBlock"
    | "productCardBlock"
    | "link"
    | "sideNav";

type CommonEventTypes = "clicked" | "hovered" | "loading";

type JSWContainerTypes =
    | CommonContainersTypes
    | "featuresSection"
    | "benefitsSection"
    | "banner-link-button"
    | "pricingQuiz"
    | "devOpsSection"
    | "integrationSection"
    | "workflowSection"
    | "pronouncedCtaSection"
    | "timelineSection"
    | "reportsAndInsightsSection"
    | "dragAndDropSection"
    | "exactTargetForm"
    | "agileCardLink"
    | "videoEmbedInline"
    | "communityCtaSection";

type JSMContainerTypes =
    | CommonContainersTypes
    | "benefitsSection"
    | "featuresSection"
    | "videoEmbedInline"
    | "linkButton"
    | "videoLink";

type ConfluenceContainerTypes =
    | CommonContainersTypes
    | "featuresSection"
    | "benefitsSection"
    | "contentTypesSection"
    | "additionalResourcesSection"
    | "videoEmbedInline"
    | "videoLink"
    | "mobileSection"
    | "templatesSection"
    | "templatesTabCard"
    | "aiSection";

type CustomerContainerTypes =
    | CommonContainersTypes
    | "customerStorySection"
    | "customerStoryCard"
    | "customerStoryFilterButton"
    | "customerStoryFilterModal"
    | "customerStoryFilterClear"
    | "customerStorySearchBar"
    | "customerStorySearchButton"
    | "customerStorySearchCloseButton";

type JiraFeaturesContainerTypes =
    | CommonContainersTypes
    | "jiraFeaturesAiSection";

export type DataEventProps =
    | {
          "data-product-key": Extract<
              ProductKeyTypes,
              | "confluence"
              | "confluence-PaidLpConflDocumentation"
              | "confluence-PaidLpXflowRedesignExperiment"
              | "confluence-PaidLpConflFeatures"
              | "confluence-PaidLpConflTemplate"
          >;
          "data-event-component": CommonComponentsTypes;
          "data-event-container": ConfluenceContainerTypes;
          "data-event": CommonEventTypes;
          "data-label"?: string;
          "data-label-english"?: string;
          "data-track-event"?: string;
      }
    | {
          "data-product-key": Extract<
              ProductKeyTypes,
              | "home"
              | "jiraSoftware-PaidLpJiraFeatures"
              | "jira"
              | "try"
              | "enterprise"
              | "enterpriseContactSales"
              | "enterpriseContactThanks"
          >;
          "data-event-component": CommonComponentsTypes;
          "data-event-container": CommonContainersTypes;
          "data-event": CommonEventTypes;
          "data-label"?: string;
          "data-label-english"?: string;
          "data-track-event"?: string;
      }
    | {
          "data-product-key": Extract<
              ProductKeyTypes,
              "jiraSoftware" | "jiraSoftwareFeature" | "jiraProductDiscovery"
          >;
          "data-event-component": CommonComponentsTypes;
          "data-event-container": JSWContainerTypes;
          "data-event": CommonEventTypes;
          "data-label"?: string;
          "data-label-english"?: string;
          "data-track-event"?: string;
      }
    | {
          "data-product-key": Extract<ProductKeyTypes, "jiraServiceDesk">;
          "data-event-component": CommonComponentsTypes;
          "data-event-container": JSMContainerTypes;
          "data-event": CommonEventTypes;
          "data-label"?: string;
          "data-label-english"?: string;
          "data-track-event"?: string;
      }
    | {
          "data-product-key": Extract<ProductKeyTypes, "jiraServiceManagement">;
          "data-event-component": CommonComponentsTypes;
          "data-event-container": JSMContainerTypes;
          "data-event": CommonEventTypes;
          "data-label"?: string;
          "data-label-english"?: string;
          "data-track-event"?: string;
      }
    | {
          "data-product-key": ProductKeyTypes;
          "data-event-component": CommonComponentsTypes;
          "data-event-container": CommonContainersTypes;
          "data-event": CommonEventTypes;
          "data-label"?: string;
          "data-label-english"?: string;
          "data-track-event"?: string;
      }
    | {
          "data-product-key": "customers";
          "data-event-component": CommonComponentsTypes;
          "data-event-container": CustomerContainerTypes;
          "data-event": CommonEventTypes;
          "data-label"?: string;
          "data-label-english"?: string;
      }
    | {
          "data-product-key": Extract<ProductKeyTypes, "jira" | "jiraSoftware">;
          "data-event-component": CommonComponentsTypes;
          "data-event-container": JiraFeaturesContainerTypes;
          "data-event": CommonEventTypes;
          "data-label"?: string;
          "data-label-english"?: string;
          "data-track-event"?: string;
      }
    | {
          "data-product-key": Extract<ProductKeyTypes, "search">;
          "data-event-component": CommonComponentsTypes;
          "data-event-container": CommonContainersTypes;
          "data-event": CommonEventTypes;
          "data-label"?: string;
          "data-label-english"?: string;
          "data-track-event"?: string;
      };
